import { NotificationBase } from 'src/app/shared/services/notification/notification-base';

export class NotificationTaxAndSuperSync extends NotificationBase {
  process(): void {
    this.showAlert();
  }

  protected viewNotification() {
    this.navCtrl.navigateForward('/accounts/billingpayment/tax-and-super-sync/landing');
  }
}
